/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addConsoleLogValue, updateButtonStatus } from '../../redux/action/3ds-actions';

function CardinalCollectionComponent() {
  const dispatch = useDispatch();
  const { logStages } = useSelector((state) => state.logReducer);
  const [actionUrl, setActionUrl] = useState('');
  const [cardinalCollectionFromInput, setCardinalCollectionFormInput] = useState('');
  window.addEventListener(
    'message',
    (event) => {
      if (event.origin === 'https://centinelapistag.cardinalcommerce.com') {
        const result = JSON.parse(event.data);
        const requestResponseObjet = {
          request: {
            title: 'collectDeviceData result',
            body: result
          },
          response: {
            title: '',
            body: undefined
          }
        };
        dispatch(addConsoleLogValue(requestResponseObjet, 4));
        dispatch(updateButtonStatus(4));
      }
    },
    false
  );
  useEffect(() => {
    const payerAuthStage = logStages.find((stage) => {
      if (stage.stage === 3) return stage;
      return undefined;
    });
    if (payerAuthStage !== undefined && payerAuthStage.response.value !== null) {
      const { accessToken, deviceDataCollectionUrl } =
        payerAuthStage.response.value.consumerAuthenticationInformation;
      setCardinalCollectionFormInput(accessToken);
      setActionUrl(deviceDataCollectionUrl);
    }
  }, [logStages]);
  return (
    <>
      <iframe
        sandbox
        title="cardinal_collection"
        id="cardinal_collection_iframe"
        name="collectionIframe"
        height="1"
        width="1"
        style={{ display: 'none' }}
      />
      <form
        id="cardinal_collection_form"
        method="POST"
        action={actionUrl}
        target="collectionIframe"
      >
        <input
          id="cardinal_collection_form_input"
          type="hidden"
          name="JWT"
          value={cardinalCollectionFromInput}
        />
      </form>
    </>
  );
}

export default CardinalCollectionComponent;
